/* eslint-disable react-refresh/only-export-components -- compound-component namespace pattern: the 5 wrapper functions are bundled into a Tabs object export; splitting into 5 separate files adds unnecessary churn for trivial wrappers with no independent lifecycle. */
import { Tabs as BaseTabs } from '@base-ui/react/tabs';
import type { ComponentPropsWithoutRef } from 'react';
import styles from './Tabs.module.css';

function Root(props: ComponentPropsWithoutRef<typeof BaseTabs.Root>) {
  return <BaseTabs.Root {...props} className={`${styles.root} ${props.className ?? ''}`} />;
}

function List(props: ComponentPropsWithoutRef<typeof BaseTabs.List>) {
  return <BaseTabs.List {...props} className={`${styles.list} ${props.className ?? ''}`} />;
}

function Tab(props: ComponentPropsWithoutRef<typeof BaseTabs.Tab>) {
  return <BaseTabs.Tab {...props} className={`${styles.tab} ${props.className ?? ''}`} />;
}

function Indicator(props: ComponentPropsWithoutRef<typeof BaseTabs.Indicator>) {
  return <BaseTabs.Indicator {...props} className={`${styles.indicator} ${props.className ?? ''}`} />;
}

function Panel(props: ComponentPropsWithoutRef<typeof BaseTabs.Panel>) {
  return <BaseTabs.Panel {...props} className={`${styles.panel} ${props.className ?? ''}`} />;
}

export const Tabs = { Root, List, Tab, Indicator, Panel };
